import { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { Toaster } from "react-hot-toast";
import { CircularAvatar, TableHeader, TableLoader } from "../../../components/commons";
import { CalenderIcon } from "../../../components/Icon";
import moment from "moment";
import { formatDate } from "../../../utils/commonFunctions";

type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  fetching: boolean;
  requestDataList: any;
  showSchedulingApprovalPendingModal: boolean;
  showSchedulingApprovalPendingModalData: any;
};
const ApprovalPendingJobModal = ({
  modal,
  toggleModal,
  fetching,
  requestDataList,
  showSchedulingApprovalPendingModalData,
}: AppProps) => {
  const [offset, setOffset] = useState<number>(0);
  let tableHeader = [
    {
      label: "Date",
      value: "date",
    },
    {
      label: "Hours",
      value: "hours",
    },
  ];

  return (
    <div>
      <Modal
        centered
        isOpen={modal}
        toggle={toggleModal}
        size="xl"
        backdrop="static"
      >
        <ModalHeader
          className="p-3"
          id="cross-cut"
          toggle={toggleModal}
        >Estimated Hours</ModalHeader>
        <ModalBody className="pl-4 pr-4" >
          <>
            <div
              className="pl-1"
              style={{ height: "400px", overflowY: "auto" }}
            >
              {fetching && offset === 0 ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : (
                <>
                  <div className="d-flex col-md-12 mb-3 justify-content-between">
                    <div
                      className="jobsType"
                      style={{
                        width: "50%", maxHeight: "400px", overflowY: "auto",
                      }}
                    >
                      <table className="table table-bordered thead-light">
                        <thead className="text-start sticky-table-header-without-zindex">
                          <TableHeader tableHeader={tableHeader} />
                        </thead>
                        <tbody>
                          {requestDataList?.estimate_data?.length > 0 &&
                            requestDataList?.estimate_data?.map(
                              (el: any) => {
                                return (
                                  <tr className="text-left">
                                    {tableHeader?.length > 0 &&
                                      tableHeader?.map((header: any) => {
                                        if (header?.value == "date") {
                                          return (
                                            <td className="text-left">
                                              {moment(el?.date).format(
                                                "dddd, DD-MM-YYYY"
                                              )}
                                            </td>
                                          );
                                        } else if (header?.value == "hours") {
                                          return (
                                            <td className="text-left">
                                              {el?.hours}
                                            </td>
                                          );
                                        }
                                      })}
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>

                    <div className="col-md-5 mb-3">
                      <div
                        className="mt-2 p-0"
                        style={{
                          cursor: "pointer", border: "1px solid #bfcbe1", borderRadius: "8px",
                        }}
                      >
                        <div className="list-header pl-3 pt-3">
                          Jobs Summary
                        </div>
                        <hr style={{ borderColor: "#bfcbe1" }} />

                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{
                              color: "#6e7491", fontSize: "13px", fontWeight: "500", width: "50%",
                            }}
                          >
                            Manager
                          </span>
                          <div className="d-flex">
                            <div>
                              <CircularAvatar
                              name={`${requestDataList?.manager?.first_name} ${requestDataList?.manager?.last_name ? requestDataList?.manager?.last_name : ""}`}
                              image={requestDataList?.manager?.profile_pic?.file_url}
                              /> 
                            </div>
                            <div className="ml-2">
                              <span
                                style={{
                                  width: "50%",
                                  fontSize: "14px",
                                  color: "#262a44",
                                  fontWeight: "400",
                                  paddingRight: "5px",
                                  wordWrap: "break-word",
                                }}
                              >
                                {`${requestDataList?.manager?.first_name} ${requestDataList?.manager?.last_name ? requestDataList?.manager?.last_name : ""}`}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{
                              color: "#6e7491", fontSize: "13px", fontWeight: "500", width: "50%",
                            }}
                          >
                            Job Type & ID
                          </span>
                          <span
                            style={{
                              width: "50%",
                              fontSize: "14px",
                              color: "#262a44",
                              fontWeight: "400",
                              paddingRight: "5px",
                              wordWrap: "break-word",
                            }}
                          >
                            {(showSchedulingApprovalPendingModalData?.job_id
                              ? `${showSchedulingApprovalPendingModalData?.job_id}_`
                              : "") +
                              showSchedulingApprovalPendingModalData?.job_type +
                              `_` +
                              formatDate(
                                showSchedulingApprovalPendingModalData?.period_ended
                              )}
                          </span>
                        </div>

                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{
                              color: "#6e7491", fontSize: "13px", fontWeight: "500", width: "50%",
                            }}
                          >
                            Client Name
                          </span>
                          <span
                            style={{
                              width: "50%",
                              fontSize: "14px",
                              color: "#262a44",
                              fontWeight: "400",
                              paddingRight: "5px",
                              wordWrap: "break-word",
                            }}
                          >
                            {`${showSchedulingApprovalPendingModalData?.client_name} (${showSchedulingApprovalPendingModalData?.client_code})`}
                          </span>
                        </div>
                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{ color: "#6e7491", fontSize: "13px", fontWeight: "500", width: "50%", }}
                          >
                            Target Start Date
                          </span>
                          {showSchedulingApprovalPendingModalData?.target_start_date ? (
                            <div style={{ width: "50%", alignItems: "center" }}>
                              <span
                                className="calender-icon"
                                style={{ right: "12px", top: "35px", cursor: "pointer", }}
                              >
                                {" "}
                                <CalenderIcon />
                              </span>
                              <span
                                style={{
                                  width: "50%",
                                  fontSize: "14px",
                                  paddingLeft: "3px",
                                  color: "#262a44",
                                  fontWeight: "400",
                                }}
                              >
                                {" "}
                                {showSchedulingApprovalPendingModalData?.target_start_date
                                  ? formatDate(
                                    showSchedulingApprovalPendingModalData?.target_start_date
                                  )
                                  : ""}
                              </span>
                            </div>
                          ) : (
                            <span
                              style={{ width: "50%", fontSize: "14px", color: "#262a44", fontWeight: "400", }}
                            >
                              --/--
                            </span>
                          )}
                        </div>
                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{ color: "#6e7491", fontSize: "13px", fontWeight: "500", width: "50%", }}
                          >
                            Target End Date
                          </span>
                          {showSchedulingApprovalPendingModalData?.target_end_date ? (
                            <div style={{ width: "50%", alignItems: "center" }}>
                              <span
                                className="calender-icon"
                                style={{ right: "12px", top: "35px", cursor: "pointer", }}
                              >
                                {" "}
                                <CalenderIcon />
                              </span>
                              <span
                                style={{ width: "50%", fontSize: "14px", paddingLeft: "3px", color: "#262a44", fontWeight: "400", }}
                              >
                                {" "}
                                {showSchedulingApprovalPendingModalData?.target_end_date
                                  ? formatDate(
                                    showSchedulingApprovalPendingModalData?.target_end_date
                                  )
                                  : ""}
                              </span>
                            </div>
                          ) : (
                            <span
                              style={{ width: "50%", fontSize: "14px", color: "#262a44", fontWeight: "400", }}
                            >
                              --/--
                            </span>
                          )}
                        </div>
                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{ color: "#6e7491", fontSize: "13px", fontWeight: "500", width: "50%", }}
                          >
                            Schedule Status
                          </span>
                          <span
                            style={{
                              padding: "4px 14px", color: "#f3a119", background: "#faedd8", borderRadius: "16px", fontSize: "12px", fontWeight: "400",
                            }}
                          >
                            {showSchedulingApprovalPendingModalData?.schedule_status === 1
                              ? "Approval Pending"
                              : ""}
                          </span>
                        </div>
                        <div className="inside-card-header d-flex w-100 pt-4 pl-3 pb-3">
                          <span
                            style={{ color: "#6e7491", fontSize: "13px", fontWeight: "500", width: "50%", }}
                          >
                            Job Details
                          </span>
                          <span
                            style={{
                              width: "50%",
                              fontSize: "14px",
                              lineHeight: "23px",
                              color: "#262a44",
                              fontWeight: "400",
                              paddingRight: "8px",
                              wordWrap: "break-word",
                            }}
                          >
                            {showSchedulingApprovalPendingModalData?.job_description}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                </>
              )}
            </div>
          </>
        </ModalBody>
      </Modal>
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.scheduling.fetching,
  requestDataList: state.scheduling.reEstimateDataList,
});

export default connect(
  mapStateToProps
)(ApprovalPendingJobModal);
